import { render, staticRenderFns } from "./ContactsGraph.vue?vue&type=template&id=3220f57e&scoped=true&"
import script from "./ContactsGraph.vue?vue&type=script&lang=js&"
export * from "./ContactsGraph.vue?vue&type=script&lang=js&"
import style0 from "./ContactsGraph.vue?vue&type=style&index=0&id=3220f57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220f57e",
  null
  
)

export default component.exports